var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import styled from "styled-components";

var IconLoader = function IconLoader(props) {
  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" })
  );
};

export default styled(IconLoader).withConfig({
  displayName: "IconLoader",
  componentId: "b458ub-0"
})(["width:1em;height:1em;path{fill:", ";}"], function (props) {
  return props.theme[props.color] || "currentColor";
});